import React from 'react'

import TextHeader from '@abra/elements/table/headers/Text'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'

const Header = () => <>
  <TableCell align='center'>
    <TextHeader label={I18n.t('status.label', { count: 1 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('type.label', { count: 1 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('template.label', { count: 2 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('export.from')} />
  </TableCell>
</>

export default React.memo(Header)
